<template>
   <span v-if="splitsCount > 0">
     <Dialog ref="dialog"
             width="430px"
             type="warning"
             mode="centered"
             icon="fas fa-cubes"
             @confirm="addSplits"
             :show-confirm="true"
             title="Agregar subordenes splits">
       <p>Hay {{splitsCount}} subordenes con splits.<br>
            ¿Desea agregarlas al administrador de pedidos?</p>
     </Dialog>
   </span>
</template>

<script>
import Dialog from '../../base/Dialog.vue';

export default {
  name: 'SuborderSplit',
  components: {
    Dialog,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
    splitsCount: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      list: this.value,
    };
  },
  methods: {
    openModal() {
      this.$refs.dialog.visible(true);
    },
    addSplits() {
      this.list = this.value.slice()
        .filter(s => s.splits)
        .map(s => s.splits).flat()
        .filter(s => !(this.value.map(soc => soc.suborder)).includes(s.suborder))
        .map(s => Object.assign(s, { sectors: [], verified: true }))
        .concat(this.value.slice().map(({ splits, ...item }) => item));
      this.$emit('input', this.list);
      this.$notify({
        type: 'success',
        title: 'Carga de splits completada',
        message: 'Todas las split se cargaron a la lista',
      });
    },
  },
};
</script>

<style lang="scss" scoped/>
